const statuses = {
  0: { label: '禁用', color: 'red' },
  1: { label: '正常', color: 'green' },
  2: { label: '已注销', color: 'default' },
};

export const userStatusPresentation = (status) => statuses[status] || { label: '未知状态', color: 'default' };
